<template>
    <div class="main-container-form">
      <div class="container-form">
          <Stations
            v-if="stations"
          />
          <RangeOfYears
            v-if="rangeOfYears"
            :initDateDefault="minDate"
          />
          <VariablesContainer
            v-if="variablesContainer"
            :variables="availableVariables"
            :labels="labels_variables"
            :particularMaterial='particularMaterial'
          />
          <div class="button-container">
              <button
              class="show-send"
              :class="(seeButton) ? '' : 'button-send'"
              :disabled='!seeButton'
              @click="ChangeView()"
              >
                Enviar
              </button>
          </div>
      </div>
      <div class="table-and-dropdown">
        <MetodologicalFileDropdown :items="optionsMetodologicalFile"/>
      </div>
    </div>
  </template>

  <script>
  import Stations from '../forms/Stations.vue'
  import RangeOfYears from '../forms/RangeOfYears.vue'
  import { mapState, mapActions } from 'vuex'
  import VariablesContainer from '../../components/variables.vue'
  import MetodologicalFileDropdown from './MetodologicalFileDropdown.vue'

  export default {
    components: {
      Stations,
      RangeOfYears,
      VariablesContainer,
      MetodologicalFileDropdown
    },
    inject: ['typology'],

    props: {
      stations: Boolean,
      rangeOfYears: Boolean,
      particularMaterial: Boolean,
      variablesContainer: Boolean,
      optionsMetodologicalFile: Object,
      viewRoute: String,
    },
    computed: {
      ...mapState(['availableVariables', 'seeButton', 'station_id_selected', 'variablesSelected', 'initDate', 'endDate', 'labels_variables',
        'availableParticulateMaterial', 'mode', 'minDate'])
    },
    methods: {
      ...mapActions(['queryGroundWaterData', 'Change_tableHeader', 'queryAirQualityData', 'queryHidrometeorologicalData']),

      ChangeView () {
        switch (this.typology) {
          case 'hydrometeorological':
          this.queryHidrometeorologicalData()
          break;

          case 'groundWater':
          this.queryGroundWaterData()
          break;

          case 'airQuality':
          this.queryAirQualityData()
          break;

          case 'hydrological':
          this.queryHidrometeorologicalData()
          break;

          default:
          console.log(`It cannot be routed. Invalid typology: ${this.typology}.`)
        }
        this.$router.push(this.viewRoute)
        this.Change_tableHeader()
      }
    }
  }
  </script>

  <style scoped>
  .main-container-form {
    display: grid;
    grid-template-columns: 70% 30%;
  }
  .container-form {
    margin-right: 2rem;
    margin-left: 9rem;
    border: solid #F0F0F0;
    padding: 1rem;
  }
  .button-container {
    display: flex;
    justify-content: center;
    margin-left: 4rem;
  }
  .table-and-dropdown {
    width: 100%;
  }
  .show-send {
    width: 25em;
    color: white;
    height: 2.5em;
    margin-top: 2em;
    margin-bottom: 2em;
    border: none;
    background-color: #777777;
    font-family: "Ancizar-bold", Helvetica, Arial;
  }
  .button-send{
      width: 25em;
      color: white;
      height: 2.5em;
      margin-top: 2em;
      margin-bottom: 2em;
      border: none;
      background-color: #bdbdbd;
  }

  @media (max-width: 769px) {
    .main-container-form {
      display: flex;
      flex-flow: row wrap;
    }

    .container-form {
      margin-right: 0;
      width: 100%;
    }
  }
  </style>